/**
 * 一番上まで戻す。
 *
 * 進み具合の表示は画面の上にあるため、下の方を見ているときに送信を始めると
 * 何も起きていないように見える。動きを付けて戻し、そこに何かが出たことを示す。
 */
export function scrollToTop(): void {
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  window.scrollTo({ top: 0, behavior: reduced ? "auto" : "smooth" });
}
